export enum HoursToInvalidateEnum {
    ONE_HOUR = 1,
    TWO_HOUR = 2,
    THREE_HOUR = 3,
    FOUR_HOUR = 4,
    FIVE_HOUR = 5,
    SIX_HOUR = 6,
    SEVEN_HOUR = 7,
    EIGHT_HOUR = 8,
}

interface HoursToInvalidateWrapper {
    enum: HoursToInvalidateEnum;
    description?: string;
}

export class UserInvitationTempModel {
    firstName: string = "";
    lastName: string = "";
    phone: string = "";
    email: string = "";
    hoursToInvalidate: HoursToInvalidateWrapper|number|null = null;

    constructor(u?:Partial<UserInvitationTempModel>) {
        Object.assign(this, u)
    }

    isValid():boolean {
        return !!this.firstName && 
            (!!this.phone || !!this.email) && 
            !!this.hoursToInvalidate
    }

    normalize():any {
        return {
            firstName: this.firstName,
            lastName: this.lastName,
            phone: this.phone,
            email: this.email,
            hoursToInvalidate: this.hoursToInvalidate ? (this.hoursToInvalidate as HoursToInvalidateWrapper).enum : 1,
        }
    }
}
